export const pollSchedule = [
  {
    id: 1,
    weekNumber: '1',
    openDate: '2022-01-08T00:00:00.00',
  },
  {
    id: 2,
    weekNumber: '2',
    openDate: '2022-01-16T00:00:00.00',
  },
  {
    id: 3,
    weekNumber: '3',
    openDate: '2022-01-23T00:00:00.00',
  },
  {
    id: 4,
    weekNumber: '4',
    openDate: '2022-01-30T00:00:00.00',
  },
  {
    id: 5,
    weekNumber: '5',
    openDate: '2022-02-06T00:00:00.00',
  },
];
